import { ViewModel, View, ObservableArray } from "binder"
import { ActivityTypeManipulationView } from "./activityTypeManipulation-view"
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ActivityTypeEditorViewModel, ActivityTypeInserter, ActivityTypeUpdater } from "./activityTypeEditor/activityTypeEditor-viewModel";
import { IActivityType } from "./IActivityType";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";

export class ActivityTypeManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف نوع OP';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.activityTypes = ObservableArray.create<ActivityType>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ActivityTypeManipulationView();
    }
    public getTypeId(): string {
        return "VM-4A0E1269-8948-4A64-9311-D7EE9B8F52AB"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set activityTypes(v: ObservableArray<ActivityType>) { this._activityTypes = v; } public get activityTypes(): ObservableArray<ActivityType> { return this._activityTypes; } private _activityTypes: ObservableArray<ActivityType>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ActivityTypeServices/ListAllActivityTypes', {
                FilteringInformation: filteringInformation
            });
            this.activityTypes.update(...result.ActivityTypes.map((x, i) => {
                let a = new ActivityType(this);
                a.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                a.id = x.Id;
                a.name = x.Name;
                a.code = x.Code;
                return a;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ActivityTypeEditorViewModel(this, new ActivityTypeInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(activityType: IActivityType) {
        let popup = new ActivityTypeEditorViewModel(this, new ActivityTypeUpdater());
        await activityType.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(activityType: ActivityType): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ActivityTypeServices/DeleteActivityType", {
                    ActivityTypeId: activityType.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ActivityType extends ViewModel implements IActivityType {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ActivityTypeManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ActivityTypeManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;

    async cloneTo(activityType: IActivityType) {
        activityType.id = this.id;
        activityType.name = this.name;
        activityType.code = this.code;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
